$(function () {
    seo.init();
});
var seo = {
    init: function() {
        $('.seo-get').bind('click', function () {
            $.get( $(this).data('url'), function( data ) {
                $('#seo_edit').remove();
                $(document.body).prepend(data);
                const el = document.querySelector('#seo_edit');
                new bootstrap.Modal(el, {}).show();
            });
        });

        $(document.body).on('click', '.seo-save', function () {
            $(this).closest('.modal').find('form').submit();
        });
    }
};

